import React from "react";

import WarningImage from "@common/assets/images/warning.png";
import Button from "@common/components/Button/Button";
import { ModalProps } from "@common/components/Modal/Modal";
import { ModalHeaderProps } from "@common/components/Modal/ModalHeader/ModalHeader";
import { ApiKey, ApiKeyType } from "@common/models/ApiKey.model";
import { Flex } from "@common/styles/reusable/Flex/Flex.styles";
import * as Styled from "@main/pages/Administration/components/ModalBody/ModalBody.styles";

interface Props {
  deleteApiKey: () => void;
  apiKey: ApiKey | undefined;
  loading: boolean;
  Modal: React.ForwardRefExoticComponent<ModalProps & ModalHeaderProps & React.RefAttributes<unknown>>;
  internalProps?: ModalProps;
}

export default function DeleteApiKeyModalBody({ deleteApiKey, apiKey, loading, Modal, internalProps }: Props) {
  const handleDeleteApiKey = (e?: React.MouseEvent<Element, MouseEvent>) => {
    e?.preventDefault();
    deleteApiKey();
  };

  let title = "",
    modalText = "",
    buttonText = "";

  const shortenedApiKey = apiKey?.key ? apiKey.key.slice(0, 6) + "..." : "";
  if (apiKey?.type === ApiKeyType.SDK) {
    title = `Delete App API key ${shortenedApiKey}`;
    modalText =
      "This action is permanent and cannot be undone.\n" +
      "Deleting this key will immediately disconnect any app using it. Users will no longer be able to submit tickets or reports to Shake.\n" +
      "You must update your app’s initialization code with a new key to restore service.";
    buttonText = "Delete App API key";
  }
  if (apiKey?.type === ApiKeyType.API) {
    title = `Delete REST API key ${shortenedApiKey}`;
    modalText =
      "This action is permanent and cannot be undone.\n" +
      "Deleting this key will immediately revoke access for all connected scripts and integrations. They will no longer be able to pull or push Shake data.\n" +
      "You must update your integration headers with a new key to restore access.";
    buttonText = "Delete REST API key";
  }

  return (
    <Modal
      {...internalProps}
      heading={title}
      buttonElement={
        <Button
          type="button"
          size="small"
          color="red"
          disabled={loading}
          loadingText={loading && "Deleting..."}
          onClick={(e) => handleDeleteApiKey(e)}
        >
          {buttonText}
        </Button>
      }
    >
      <Flex $column>
        <img
          style={{ alignSelf: "center", marginBottom: "2.4rem" }}
          src={WarningImage}
          alt="Warning"
        />
        <Styled.Subtitle>{modalText}</Styled.Subtitle>
      </Flex>
    </Modal>
  );
}
